import React from "react";
import { ReactComponent as PlanIcon } from "../../../../../../assets/icons/document.svg";
import { ReactComponent as LinkIcon } from "../../../../../../assets/icons/link.svg";

export const PlanItem = ({ item, defaultName, className }) => {
  const handleClickPlan = (src: string) => {
    window.open(src, "_blank");
  };

  return (
    <li className={className}>
      <button
        type="button"
        className="flex w-full items-center gap-4 rounded-[16px] border border-[#edf1f5] px-4 py-4 text-left transition-colors hover:border-[#d0d5dd] hover:bg-[#fafbfc]"
        onClick={() => handleClickPlan(item.src)}
      >
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] bg-[#f4f6f8] text-[#101828]">
          <PlanIcon width="24" height="24" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[15px] font-semibold text-[#111827]">
            {item.name || defaultName}
          </div>
          <div className="mt-1 text-[13px] text-[#667085]">
            Открыть в новой вкладке
          </div>
        </div>
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#edf1f5] bg-white text-[#667085]">
          <LinkIcon width="16" height="16" />
        </div>
      </button>
    </li>
  );
};
